export enum ECrudFilterType {
  SEARCH = 1,
  EXACT = 2,
  BOOLEAN = 7,
  DATE = 3,
  MORE = 4,
  LESS = 5,
  IN = 6,
  UUID = 8,
}
